import React, { Component } from 'react';
import {
    Grid,
    Radio,
    FormControlLabel,
    FormControl,
    RadioGroup,
    Chip,
    Typography
} from "@material-ui/core";
import moment from 'moment'
import { withTranslation } from 'react-i18next';
import WrappedKeyboardDatePicker from './WrappedKeyboardDatePicker';

class CustomSelector extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedPredefinedDate: this.props.selectedRadioButton
        };
    }

    handleChangePredefinedDates = (e) => {
        const currentDate = moment(new Date());

        const currentQuarterNumber = moment(currentDate).quarter();
        const previousQuarterNumber = currentQuarterNumber - 1;

        const startCurrentQuarter = moment(moment().quarter(currentQuarterNumber)).startOf('quarter')
        const endCurrentQuarter = moment(moment().quarter(currentQuarterNumber)).endOf('quarter').add(1, 'days')

        const startPreviousQuarter = moment(moment().quarter(previousQuarterNumber)).startOf('quarter')
        const endPreviousQuarter = moment(moment().quarter(previousQuarterNumber)).endOf('quarter').add(1, 'days')

        const currentStartOfMonth = moment(currentDate).startOf('month')
        const currentEndOfMonth = moment(currentDate).endOf('month').add(1, 'days')

        const previousStartOfMonth = moment(currentDate).subtract(1, 'months').startOf('month')
        const previousEndOfMonth = moment(currentDate).subtract(1, 'months').endOf('month').add(1, 'days')

        const currentStartOfYear = moment().startOf('year');
        const currentEndOfYear = moment().endOf('year').add(1, 'days');

        const previousStartOfYear = moment(currentDate).startOf('year').subtract(12, 'months');
        const previousEndOfYear = moment(currentDate).endOf('year').subtract(12, 'months').add(1, 'days')

        switch (e.target.value) {
            case "currentMonth":
                this.props.changeDates(currentStartOfMonth, currentEndOfMonth, "currentMonth")
                this.setState({ selectedPredefinedDate: "currentMonth" })
                this.props.monthDiff(new Date(currentStartOfMonth), new Date(currentEndOfMonth))
                break;
            case "previousMonth":
                this.props.changeDates(previousStartOfMonth, previousEndOfMonth, "previousMonth")
                this.setState({ selectedPredefinedDate: "previousMonth" })
                this.props.monthDiff(new Date(previousStartOfMonth), new Date(previousEndOfMonth))
                break;
            case "currentQuarter":
                this.props.changeDates(startCurrentQuarter, endCurrentQuarter, "currentQuarter")
                this.setState({ selectedPredefinedDate: "currentQuarter" })
                this.props.monthDiff(new Date(startCurrentQuarter), new Date(endCurrentQuarter))
                break;
            case "previousQuarter":
                this.props.changeDates(startPreviousQuarter, endPreviousQuarter, "previousQuarter")
                this.setState({ selectedPredefinedDate: "previousQuarter" })
                this.props.monthDiff(new Date(startPreviousQuarter), new Date(endPreviousQuarter))
                break;
            case "previousYear":
                this.props.changeDates(previousStartOfYear, previousEndOfYear, "previousYear")
                this.setState({ selectedPredefinedDate: "previousYear" })
                this.props.monthDiff(new Date(previousStartOfYear), new Date(previousEndOfYear))
                break;
            case "currentYear":
                this.props.changeDates(currentStartOfYear, currentEndOfYear, "currentYear")
                this.setState({ selectedPredefinedDate: "currentYear" })
                this.props.monthDiff(new Date(currentStartOfYear), new Date(currentEndOfYear))
                break;
            case "customRange":
                this.props.changeDates(null, null, "customRange")
                this.setState({ selectedPredefinedDate: "customRange" })
                this.props.monthDiff(null, null)
                break;
            default:
        }
    }

    render() {
        let { selectedFrom, selectedInventory, selectedTo, numberOfMonths } = this.props

        return (<>
            {selectedInventory !== null && <>
                <Grid item container direction="column" xs={12} sm={12} md={12} lg={4} xl={3} >
                    <Grid container direction="row" spacing={3} style={{ width: "100%", margin: '0px', backgroundColor: '#d3e4fb' }}>
                        <Grid item container direction="column" xs={12} sm={12} md={12} lg={6} xl={7}>
                            <Grid container direction="row" spacing={2}>
                                <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid item container>
                                        <WrappedKeyboardDatePicker
                                            name="selectedFrom"
                                            label={this.props.t("from")}
                                            value={selectedFrom ? moment(selectedFrom, "DD-MM-YYYY") : null}
                                            onChange={this.props.handleChangeFromDate}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid item container>
                                        <WrappedKeyboardDatePicker
                                            name="selectedTo"
                                            label={this.props.t("to")}
                                            value={selectedTo ? moment(selectedTo, "DD-MM-YYYY") : null}
                                            onChange={this.props.handleChangeToDate}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid item container style={{ textAlign: 'center' }}>
                                        <Chip
                                            style={{ width: '100%' }}
                                            label={this.props.t("selected_date_range") + " : " + numberOfMonths + " " + this.props.t("month(s)")}
                                            color="primary"
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item container direction="column" xs={3} sm={3} md={4} lg={6} xl={5}>
                            <Grid item container>
                                <FormControl component="fieldset" >
                                    <RadioGroup name="dates" value={this.state.selectedPredefinedDate !== null ? this.state.selectedPredefinedDate : this.props.selectedRadioButton} onChange={(e) => { this.handleChangePredefinedDates(e) }}>
                                        <FormControlLabel value="currentMonth" control={<Radio color="primary" size="small" style={{ padding: "3px" }} />} label={<Typography className={this.state.selectedPredefinedDate === "currentMonth" ? "custom-radio-button" : /* this.props.selectedRadioButton === "currentMonth" ? "custom-radio-button" : */ null} style={{ fontSize: "14px" }}>{this.props.t("current_month")}</Typography>} />
                                        <FormControlLabel value="previousMonth" control={<Radio color="primary" size="small" style={{ padding: "3px" }} />} label={<Typography className={this.state.selectedPredefinedDate === "previousMonth" ? "custom-radio-button" : /* this.props.selectedRadioButton === "previousMonth" ? "custom-radio-button" :  */null} style={{ fontSize: "14px" }}>{this.props.t("previous_month")}</Typography>} />
                                        <FormControlLabel value="currentQuarter" control={<Radio color="primary" size="small" style={{ padding: "3px" }} />} label={<Typography className={this.state.selectedPredefinedDate === "currentQuarter" ? "custom-radio-button" : /* this.props.selectedRadioButton === "currentQuarter" ? "custom-radio-button" : */ null} style={{ fontSize: "14px" }}>{this.props.t("current_quarter")}</Typography>} />
                                        <FormControlLabel value="previousQuarter" control={<Radio color="primary" size="small" style={{ padding: "3px" }} />} label={<Typography className={this.state.selectedPredefinedDate === "previousQuarter" ? "custom-radio-button" : /* this.props.selectedRadioButton === "previousQuarter" ? "custom-radio-button" : */ null} style={{ fontSize: "14px" }}>{this.props.t("previous_quarter")}</Typography>} />
                                        <FormControlLabel value="currentYear" control={<Radio color="primary" size="small" style={{ padding: "3px" }} />} label={<Typography className={this.state.selectedPredefinedDate === "currentYear" ? "custom-radio-button" : /* this.props.selectedRadioButton === "currentYear" ? "custom-radio-button" :  */null} style={{ fontSize: "14px" }}>{this.props.t("current_year")}</Typography>} />
                                        <FormControlLabel value="previousYear" control={<Radio color="primary" size="small" style={{ padding: "3px" }} />} label={<Typography className={this.state.selectedPredefinedDate === "previousYear" ? "custom-radio-button" : /* this.props.selectedRadioButton === "previousYear" ? "custom-radio-button" :  */null} style={{ fontSize: "14px" }}>{this.props.t("previous_year")}</Typography>} />
                                        <FormControlLabel value="customRange" control={<Radio color="primary" size="small" style={{ padding: "3px" }} />} label={<Typography className={this.state.selectedPredefinedDate === "customRange" ? "custom-radio-button" : /* this.props.selectedRadioButton === "customRange" ? "custom-radio-button" : */ null} style={{ fontSize: "14px" }}>{this.props.t("custom_range")}</Typography>} />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </>}
        </>);
    }
}

export default withTranslation()(CustomSelector);
